import React from 'react';

function FeedbackGiveMoneyIcon() {
  return (
    <svg width={22} height={22} fill="none">
      <title>Ilustração de transferência</title>
      <path
        d="M15.203 1.681l-.887.7c-1.01-.33-2.123-.501-3.316-.501-5.495 0-9.12 3.625-9.12 9.12 0 5.495 3.625 9.12 9.12 9.12 5.495 0 9.12-3.625 9.12-9.12 0-1.66-.332-3.164-.96-4.452V4.7C20.41 6.395 21.08 8.556 21.08 11c0 6.025-4.055 10.08-10.08 10.08S.92 17.025.92 11 4.975.92 11 .92c1.526 0 2.942.26 4.203.761z"
        fill="#111"
      />
      <path
        d="M18.2 2.52v5.12h-.96V2.52l-2.023 1.595-.594-.754L17.72.92l3.097 2.441-.594.754L18.2 2.521zM11.48 16.28v-.991c1.402-.186 2.4-1.177 2.4-2.369 0-1.382-.75-1.849-2.756-2.384-1.595-.425-2.044-.704-2.044-1.456 0-.816.683-1.44 1.92-1.44.825 0 1.546.498 1.813 1.221l.9-.332c-.352-.955-1.212-1.644-2.233-1.81V5.72h-.96v.987c-1.473.172-2.4 1.136-2.4 2.373 0 1.382.75 1.85 2.756 2.384 1.595.425 2.044.705 2.044 1.456 0 .763-.774 1.44-1.92 1.44-.823 0-1.543-.497-1.81-1.219l-.9.334c.352.953 1.21 1.64 2.23 1.806v.999h.96z"
        fill="#111"
      />
    </svg>
  );
}

export default FeedbackGiveMoneyIcon;
